/* eslint-disable */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Badge } from '@edx/paragon';
import WidgetNavbar from 'containers/WidgetContainers/WidgetNavbar';
import urls from 'data/services/lms/urls';
import { COLLAPSED_NAVBAR } from 'widgets/RecommendationsPaintedDoorBtn/constants';
import { useIntl } from '@edx/frontend-platform/i18n';
import { AppContext } from '@edx/frontend-platform/react';
import { getConfig } from '@edx/frontend-platform';
import { reduxHooks } from 'hooks';
import { findCoursesNavDropdownClicked } from '../hooks';
import messages from '../messages';
import { Link } from 'react-router-dom';
import './collapse.css'


const NavbarWithDropdown = ({ isOpen }) => {
  const [isProgramsDropdownOpen, setIsProgramsDropdownOpen] = useState(false);
  const [isCatalogueDropdownOpen, setIsCatalogueDropdownOpen] = useState(false);

  const toggleProgramsDropdown = () => {
    setIsProgramsDropdownOpen(!isProgramsDropdownOpen);
    if (isCatalogueDropdownOpen) {
      setIsCatalogueDropdownOpen(false);
    }
  };

  const toggleCatalogueDropdown = () => {
    setIsCatalogueDropdownOpen(!isCatalogueDropdownOpen);
    if (isProgramsDropdownOpen) {
      setIsProgramsDropdownOpen(false);
    }
  };

  const { formatMessage } = useIntl();
  const { authenticatedUser } = React.useContext(AppContext);
  const dashboard = reduxHooks.useEnterpriseDashboardData();
  const { courseSearchUrl } = reduxHooks.usePlatformSettingsData();
  const exploreCoursesClick = findCoursesNavDropdownClicked(urls.baseAppUrl(courseSearchUrl));

  return (
    isOpen && (
      <div className="d-flex flex-column shadow-sm nav-small-menu r4c-collapsed-menu-lists">
        <Button onClick={toggleProgramsDropdown} variant="inverse-primary" className="r4c-dropdown-icon r4c-menu-item">
          My courses
        </Button>
        <div className={`${isProgramsDropdownOpen ? 'r4c-dropdown-menu' : 'dropdown-menu'}`}>
          <ul className='r4c-dashboard-header-list' >
            <li className='r4c-dashboard-header-list-item'>
              <Link className='r4c-dashboard-header-list-link r4c-menu-item' to={urls.baseAppUrl(urls.myProgramsUrl)} >My Micro-programmes</Link>
            </li>
            <li className='r4c-dashboard-header-list-item'>
              <Link className='r4c-dashboard-header-list-link r4c-menu-item' to='/learner-dashboard/'>My Micro-credentials</Link>
            </li>
          </ul>
        </div>
        <Button onClick={toggleCatalogueDropdown} variant="inverse-primary" className="r4c-dropdown-icon r4c-menu-item">
        Catalogue
        </Button>
        <div className={`${isCatalogueDropdownOpen ? 'r4c-dropdown-menu' : 'dropdown-menu'}`}>
          <ul className='r4c-dashboard-header-list' >
            <li className='r4c-dashboard-header-list-item'>
              <Link className='r4c-dashboard-header-list-link r4c-menu-item'  to={urls.baseAppUrl(urls.programsUrl)}> Micro-programmes </Link>
            </li>
            <li className='r4c-dashboard-header-list-item'>
              <Link className='r4c-dashboard-header-list-link r4c-menu-item' to={urls.baseAppUrl(courseSearchUrl)}>Micro-credentials</Link>
            </li>
          </ul>
        </div>
       
        {/* <WidgetNavbar placement={COLLAPSED_NAVBAR} />
        <Button as="a" href={getConfig().SUPPORT_URL} variant="inverse-primary">
          {formatMessage(messages.help)}
        </Button> */}
        {authenticatedUser && (
          <>
            {!dashboard && getConfig().CAREER_LINK_URL && (
              <Button href={`${getConfig().CAREER_LINK_URL}`}>
                {formatMessage(messages.career)}
                <Badge className="px-2 mx-2" variant="warning">
                  {formatMessage(messages.newAlert)}
                </Badge>
              </Button>
            )}
            <Button
              as="a"
              href={`${getConfig().LMS_BASE_URL}/u/${authenticatedUser.username}`}
              variant="inverse-primary"
              className="r4c-menu-item"
            >
              {formatMessage(messages.profile)}
            </Button>
            <Button
              as="a"
              href={`${getConfig().LMS_BASE_URL}/account/settings`}
              variant="inverse-primary"
              className="r4c-menu-item"
            >
              {formatMessage(messages.account)}
            </Button>
      
            <Button
              as="a"
              href={getConfig().LOGOUT_URL}
              variant="inverse-primary"
              className="r4c-menu-item"
            >
              {formatMessage(messages.signOut)}
            </Button>
          </>
        )}
      </div>
    )
  );
};

NavbarWithDropdown.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default NavbarWithDropdown;
